import React from 'react';

const Step1UserType = React.memo(function Step1UserType({ onSelectUserType }) {
  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Book an Appointment</h2>
        <p className="text-gray-600">Are you a new or existing patient?</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <button
          onClick={() => onSelectUserType('new')}
          className="p-6 border-2 border-gray-200 rounded-lg hover:border-orange-500 hover:bg-orange-50 transition-colors text-left"
        >
          <div className="text-2xl mb-2">👤</div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">New Patient</h3>
          <p className="text-sm text-gray-600">I'm scheduling my first appointment with NAMHS</p>
        </button>

        <button
          onClick={() => onSelectUserType('existing')}
          className="p-6 border-2 border-gray-200 rounded-lg hover:border-orange-500 hover:bg-orange-50 transition-colors text-left"
        >
          <div className="text-2xl mb-2">🏥</div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Existing Patient</h3>
          <p className="text-sm text-gray-600">I've been seen at NAMHS before</p>
        </button>
      </div>
    </div>
  );
});

export default Step1UserType;
